<div class="preview-wrap">
  <div #canvas class="preview-canvas"></div>
</div>
